import nvSharedModelsModule from '../nv.shared.models.module';

angular.module(nvSharedModelsModule).factory('Flag', function(NvBaseModel, PublicConfig, $http) {
  const PERMISSIONING_MODEL_NAME = 'FLAG';
  const relationToUserPath = 'createdBy.userId';

  let Flag = NvBaseModel(
    // eslint-disable-line new-cap
    '/v1/flags/:schoolId',
    { id: '@_id', schoolId: '@schoolId' },
    null,
    null,
    PERMISSIONING_MODEL_NAME,
    relationToUserPath,
  );

  return Flag;
});
